import { API_BASE_URL } from '@/config/config';
import { logError } from '@/utils/errorHandler';

export interface ContactFormData {
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  company: string;
  jobTitle: string;
  companySize: string;
  purpose: string;
  currentSolution?: string;
  message?: string;
}

export interface ContactFormResponse {
  success: boolean;
  message: string;
}

class ContactService {
  private apiUrl = `${API_BASE_URL}/api`;

  async submitContactForm(data: ContactFormData): Promise<ContactFormResponse> {
    try {
      const response = await fetch(`${this.apiUrl}/contact/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          first_name: data.firstName,
          last_name: data.lastName,
          email: data.email,
          phone: data.phone,
          company: data.company,
          job_title: data.jobTitle,
          company_size: data.companySize,
          purpose: data.purpose,
          current_solution: data.currentSolution,
          message: data.message,
          recipient_email: 'info@kernlogic.com',
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return {
        success: true,
        message: result.message || 'Your message has been sent successfully!',
      };
    } catch (error) {
      logError(
        'Failed to submit contact form',
        {
          component: 'contactService',
          action: 'submitContactForm',
          metadata: { data, error },
        },
        { showToast: false, userFacing: false }
      );
      return {
        success: false,
        message: 'Failed to send your message. Please try again later.',
      };
    }
  }
}

export const contactService = new ContactService();
